<script setup lang="ts">
import {socialInfo} from "../../utils/social";

definePageMeta({
  static: true,
  title: 'Política de Privacidade'
})

const breadcrumbData = [{
  title: 'Home',
  link: '/',
  subitems: [
    {title: 'Política de Privacidade'}
  ]
}]
</script>

<template>
  <div class="container pb-lg-4 mb-sm-2">
    <Breadcrumb :data="breadcrumbData"/>
    <div class="row">
      <PoliticsMenu activePage="privacy"/>

      <div class="col-lg-8 col-md-7 mb-5">
        <h1 class="mb-4 pb-lg-2 h2">Política de Privacidade</h1>
        <h4 class="h4"><b>IDENTIFICAÇÃO DO CONTROLADOR</b></h4>
        <p>
          <b>Plataforma: </b> {{ socialInfo.fantasyName }}<br>
          <b>CNPJ: </b>{{ socialInfo.cnpj }}<br>
          <b>Endereço: </b>{{ socialInfo.address }}
        </p>
        <p>Esta Política de Privacidade descreve como a Plataforma {{ socialInfo.fantasyName }} ("nós", "nosso", "a
          Plataforma")
          coleta, utiliza, compartilha e protege os dados pessoais dos usuários de seus serviços.</p>
        <h4 class="h4"><b>1. Âmbito de Aplicação</b></h4>
        <p>Esta política se aplica a todos os tratamentos de dados pessoais realizados pela Plataforma
          {{ socialInfo.fantasyName }} por meio dos sites, aplicativos, formulários, canais de atendimento e quaisquer
          outras ferramentas
          disponibilizadas para usuários, organizadores e parceiros.</p>
        <h4 class="h4"><b>2. Informações Coletadas</b></h4>
        <p>Coletamos informações fornecidas diretamente pelo usuário quando este interage com a Plataforma, tais como:
          nome, CPF/CNPJ, e‑mail, telefone, endereço, informações de pagamento, dados para emissão de ingressos e
          bilhetes, além de comunicações trocadas por meio dos canais da Plataforma.</p>
        <p>Também somos responsáveis pela coleta automática de dados técnicos e de uso (por exemplo: endereço IP,
          identificadores de cookies, modelo de dispositivo, sistema operacional, páginas acessadas, dados de
          geolocalização quando autorizada), conforme necessário para a prestação do serviço.</p>
        <h4 class="h4"><b>3. Finalidades do Tratamento</b></h4>
        <p>
          Os dados pessoais são tratados para as seguintes finalidades:
        </p>
        <ul>
          <li>Fornecimento e gestão de contas de usuário e operações de compra e venda de ingressos;</li>
          <li>Processamento de pagamentos, emissão de notas fiscais e entrega de comprovantes;</li>
          <li>Envio de comunicações relacionadas a compra, confirmação de cadastro, alterações no evento,
            cancelamentos, reembolsos e informações operacionais;
          </li>
          <li>Prevenção e detecção de fraudes e análise de risco;</li>
          <li>Cumprimento de obrigações legais e fiscais;</li>
          <li>Melhorias na Plataforma, análises estatísticas e personalização de experiência.</li>
        </ul>
        <h4 class="h4"><b>4. Bases Legais</b></h4>
        <p>
          O tratamento dos dados apoia‑se, conforme aplicável, nas seguintes bases legais previstas na legislação de
          proteção de dados:
        </p>
        <ul>
          <li>Execução de contrato ou medidas pré‑contratuais;</li>
          <li>Cumprimento de obrigação legal ou regulatória;</li>
          <li>Consentimento do titular para finalidades específicas quando exigido;</li>
          <li>Legítimo interesse da Plataforma, quando compatível com os direitos e liberdades do titular (ex.:
            prevenção de fraudes, segurança).
          </li>
        </ul>
        <h4 class="h4"><b>5. Compartilhamento de Dados</b></h4>
        <p>
          Podemos compartilhar dados pessoais com terceiros nas seguintes hipóteses:
        </p>
        <ul>
          <li>Prestadores de serviços contratados (meios de pagamento, serviços de TI, hospedagem, envio de e‑mails,
            atendimento ao cliente, suporte técnico, emissão de documentos fiscais);
          </li>
          <li>Organizadores de eventos, quando necessário para emissão e validação de ingressos;</li>
          <li>Autoridades públicas, mediante requisição legal;</li>
          <li>Em caso de operações societárias (fusão, aquisição ou venda de ativos), respeitando a legislação
            aplicável.
          </li>
        </ul>
        <p>Sempre que compartilhamos dados com fornecedores, exigimos que mantenham padrões adequados de segurança e que
          tratem os dados conforme instruções e finalidade contratada.</p>
        <h4 class="h4"><b>6. Transferência Internacional</b></h4>
        <p>Quando necessário, seus dados poderão ser transferidos para provedores localizados em outros países. Nessas
          hipóteses, adotamos garantias adequadas para proteger os dados e observamos as exigências legais
          aplicáveis.</p>
        <h4 class="h4"><b>7. Segurança dos Dados</b></h4>
        <p>Adotamos medidas técnicas e administrativas razoáveis para proteger os dados pessoais contra acesso não
          autorizado, perda, divulgação indevida e alterações. Entre as medidas estão controles de acesso, criptografia
          quando aplicável, políticas internas de segurança e contratos com fornecedores que impõem obrigações de
          confidencialidade.</p>
        <h4 class="h4"><b>8. Retenção e Eliminação</b></h4>
        <p>Reteremos os dados pessoais pelo tempo necessário para cumprir as finalidades descritas nesta Política,
          inclusive para cumprir obrigações legais e fiscais. Quando os dados não forem mais necessários, tomaremos
          medidas razoáveis para apagá‑los ou anonimizar as informações.</p>
        <h4 class="h4"><b>9. Direitos dos Titulares</b></h4>
        <p>
          Os titulares de dados têm os direitos previstos na legislação, entre eles:
        </p>
        <ul>
          <li>Confirmação da existência de tratamento;</li>
          <li>Acesso aos dados;</li>
          <li>Correção de dados incompletos, inexatos ou desatualizados;</li>
          <li>Eliminação dos dados desnecessários, excessivos ou tratados em desconformidade;</li>
          <li>Portabilidade dos dados (quando aplicável);</li>
          <li>Revogação do consentimento quando esse for a base legal do tratamento;</li>
          <li>Informação sobre as entidades públicas e privadas com as quais compartilhamos dados.</li>
        </ul>
        <p>Para exercer seus direitos, o titular poderá entrar em contato pelos canais indicados nesta Política.</p>
        <h4 class="h4"><b>10. Cookies e Tecnologias Similares</b></h4>
        <p>Utilizamos cookies e tecnologias similares para melhorar a experiência do usuário, armazenar preferências,
          realizar análises e oferecer funcionalidades essenciais. O usuário pode gerenciar as preferências de cookies
          por meio das configurações do navegador ou das ferramentas disponibilizadas na Plataforma.</p>
        <h4 class="h4"><b>11. Comunicações Comerciais</b></h4>
        <p>Quando houver consentimento, poderemos enviar comunicações comerciais sobre produtos, promoções e novidades.
          O usuário poderá, a qualquer tempo, optar por não receber essas comunicações por meio dos mecanismos de
          opt‑out disponibilizados.</p>
        <h4 class="h4"><b>12. Responsabilidade</b></h4>
        <p>Na medida permitida pela legislação aplicável, a Plataforma não será responsável por danos indiretos, lucros
          cessantes ou perdas que decorram do uso inadequado da Plataforma. Para questões relativas a responsabilidade
          por eventos específicos, aplicam‑se as regras contratuais celebradas entre as partes.</p>
        <h4 class="h4"><b>13. Alterações nesta Política</b></h4>
        <p>Podemos atualizar esta Política periodicamente. Alterações relevantes serão comunicadas aos usuários por meio
          da Plataforma ou por e‑mail, quando cabível. A data de vigência da nova versão será informada quando
          aplicável.</p>
        <h4 class="h4"><b>14. Contato</b></h4>
        <p>Para solicitações, dúvidas ou reclamações relativas a esta Política e ao tratamento de dados, entre em
          contato:<br>
          <b>Plataforma {{ socialInfo.fantasyName }}</b><br>
          <b>CNPJ: </b>{{ socialInfo.cnpj }}<br>
          <b>Endereço: </b>{{ socialInfo.address }}<br>
          <b>E‑mail de contato: </b>{{ socialInfo.emails.contact }}<br>
        </p>
        <ul>
          <li>Podemos também coletar informações relacionadas ao uso de ingressos, como histórico de compras, presença
            em eventos e preferências declaradas, a fim de melhorar a experiência do usuário.
          </li>
          <li>Gestão de solicitações de reembolso e cancelamento de ingressos;</li>
          <li>Cumprimento de determinações judiciais e administrativas;</li>
          <li>Em situações de cancelamento de eventos, os dados poderão ser compartilhados com o organizador para
            viabilizar a devolução dos valores ou compensações devidas.
          </li>
          <li>Sempre que houver transferência para países que não possuam nível adequado de proteção de dados,
            adotaremos cláusulas contratuais padrão ou instrumentos equivalentes reconhecidos pela Autoridade Nacional
            de Proteção de Dados (ANPD).
          </li>
          <li>Apesar dos esforços, nenhum sistema é totalmente seguro. Assim, não podemos garantir a segurança
            absoluta das informações contra acessos não autorizados resultantes de atos ilícitos de terceiros.
          </li>
          <li>Os dados relacionados a transações financeiras serão mantidos pelo prazo mínimo de 5 (cinco) anos,
            conforme exigências fiscais e contábeis.
          </li>
          <li>O exercício de direitos poderá estar sujeito à comprovação de identidade do solicitante para evitar
            fraudes.
          </li>
          <li>Com o consentimento do usuário, poderemos utilizar os dados de contato (como e-mail, número de WhatsApp
            e telefone) para o envio de mensagens promocionais relacionadas a eventos futuros, ofertas de ingressos,
            campanhas de marketing e novidades da Plataforma e/ou de organizadores parceiros.
          </li>
          <li>O usuário poderá, a qualquer momento, revogar esse consentimento ou optar por não receber tais
            comunicações, utilizando os mecanismos de descadastramento (opt-out) disponibilizados em cada mensagem ou
            entrando em contato diretamente com a Plataforma.
          </li>
          <li>Ressaltamos que a revogação do consentimento não afetará as comunicações necessárias à execução do
            contrato (como confirmações de compra, informações sobre o evento adquirido ou comunicações sobre
            cancelamento e reembolso).
          </li>
          <li>A Plataforma não assume responsabilidade por falhas na prestação de serviços de terceiros (como
            operadoras de pagamento, provedores de internet, servidores de hospedagem), ainda que tais falhas impactem
            a utilização dos serviços.
          </li>
          <li>O titular também poderá registrar reclamação diretamente à Autoridade Nacional de Proteção de Dados
            (ANPD), caso entenda que seus direitos não foram atendidos.
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped>
p {
  text-align: justify;
  opacity: 70;
  font-size: 14px;
}
</style>
